<template>
    <div class="location-edit-modal" @mousedown="onBackdropMouseDown" @click="onBackdropClick">
        <div class="location-edit-modal-window" style="min-height: 500px; width: 680px;" @click.stop>
            <div class="location-edit-modal-close" @click="$emit('close')">&times;</div>

            <h3>Redigera foto</h3>

            <cropper
                class="cropper"
                ref="cropper"
                :src="cropUrl"
                :stencil-props="{
                    aspectRatio: 1600 / 1000,
                    movable: true,
                    resizable: true,
                    handlers: {
                        eastNorth: true,
                        north: false,
                        westNorth: true,
                        west: false,
                        westSouth: true,
                        south: false,
                        eastSouth: true,
                        east: false,
                    }
                }"
                :resize-image="{
                    adjustStencil: false
                }"
                :min-height="250"
                :min-width="400"
                @change="change"
                :debounce="false"
                :resizeImage="false"
            />

            <h4 class="mt-5">Förhandsvisning:</h4>

            <div class="location-preview-full">
                <image-crop-preview :src="cropUrl" :coordinates="coordinates" :brightness="brightness" />
            </div>

            <div class="mt-5" style="margin-top: 20px;">
                <label>Ljusstyrka</label>
                <input type="range" min="-100" max="100" step="1" v-model.number="brightness" style="width:100%;" />
            </div>

            <div class="mt-5" style="display:flex; justify-content:flex-end;">
                <button class="btn btn-default" style="margin-right:8px;" @click="$emit('close')">Avbryt</button>
                <button class="btn btn-primary" @click="save">Spara</button>
            </div>

        </div>
    </div>
</template>

<script>

import { Cropper } from 'vue-advanced-cropper'
import 'vue-advanced-cropper/dist/style.css'
import ImageCropPreview from './image-crop-preview.vue'

export default {

    components: {
        Cropper,
        ImageCropPreview
    },

    props: {
        location: {
            required: true
        }
    },

    data () {
        return {
            coordinates: {},
            brightness: this.location.brightness || 0,
            // Tracks whether the mousedown that started this press landed
            // directly on the backdrop (not a descendant). Without this, a
            // crop-handle drag that releases outside the modal window - but
            // still within the full-screen backdrop - fires a native click on
            // the backdrop and closes the modal, even though the drag started
            // on the cropper itself.
            backdropPressStartedOnSelf: false
        }
    },

    mounted () {
        if (this.location.crop_width) {
            this.$refs.cropper.setCoordinates({
                width: this.location.crop_width,
                height: this.location.crop_height,
                left: this.location.crop_left,
                top: this.location.crop_top
            })
        }
    },

    computed: {
        cropUrl () {
            return '/storage/clinic-presentation/' + this.location.name + '.jpg'
        }
    },

    methods: {
        onBackdropMouseDown (event) {
            this.backdropPressStartedOnSelf = event.target === event.currentTarget
        },

        onBackdropClick (event) {
            if (this.backdropPressStartedOnSelf && event.target === event.currentTarget) {
                this.$emit('close')
            }

            this.backdropPressStartedOnSelf = false
        },

        change ({ coordinates }) {
            this.coordinates = coordinates
        },

        // Deferred until "Spara presentation och foton" like everything else in
        // this panel - no backend call here. The list shows the pending result
        // via the same <image-crop-preview> component, driven by these same
        // locally-held values, until the panel save actually persists them.
        save () {
            this.location.crop_width = this.coordinates.width
            this.location.crop_height = this.coordinates.height
            this.location.crop_left = this.coordinates.left
            this.location.crop_top = this.coordinates.top
            this.location.brightness = this.brightness
            this.location.locallyEdited = true

            this.$emit('close')
        }
    }

}
</script>
